import { Shark, Utils, View } from "shark-mvc";

import templateContent from "./user-edit.html";

import { folderManager } from "../../_shark_jaws/managers/folderManager";
import mainNavComponent from "../../_shark_jaws/components/mainNavComponent";
import userListView from "./userListView";
import { userManager } from "../../_shark_jaws/managers/userManager";
import { informationModalComponent } from "../../components/informationModal/informationModalComponent";

class UserEditView extends View {
	constructor () {
		super("userEditView");
		this.setTemplate(templateContent);
	}

	afterLoad () {
		const { editingUser } = Shark.get();

		if (!editingUser) {
			Shark.openPage(userListView);
		}
	}
	
	backToAgentListBtn_clickHandler () {
		Shark.openPage(userListView);
	}

	beforeLoad () {
		const { editingUser } = Shark.get();

		if (editingUser) {
			if (editingUser.hasRole("sellRepresentative")) {
				folderManager.getListByAgent("", editingUser.guid)
				.then(nousResponse => {
					const clientsFolder = Utils.safp(nousResponse.data, "type", "clients");

					if (!clientsFolder) {
						alert("Attenzione, questo account è segnato come agente ma non è correttamente configurato, se inserisce dei contenuti potrebbero andare persi, per favore clicca sul tasto 'genera cartella clienti'!");
						Shark.set({
							__showCreateClientsAutofolderBtn: true
						});
						Shark.render();
					}

					const agentFolder = nousResponse.data.filter(item => item.type === "userDocuments" && item.ownerGuid === editingUser.guid);

					if (agentFolder.length === 0) {
						alert("Attenzione, questo account è segnato come agente ma non è correttamente configurato, se inserisce dei contenuti potrebbero andare persi, per favore clicca sul tasto 'genera cartella agente'!");
						Shark.set({
							__showCreateAgentAutofolderBtn: true
						});
						Shark.render();
					}
				});
			}
		}
	}

	createAgentAutofolder (currUser) {
		folderManager.getListByAgent("", currUser.guid)
		.then(nousResponse => {
			const agentFolder = nousResponse.data.filter(item => item.type === "userDocuments" && item.ownerGuid === currUser.guid);

			if (agentFolder.length === 0) {
				const newProjectFolder = Shark.getInstance("Folder", {
					clientGuid: "",
					name: "Archivio Venditore",
					ownerGuid: currUser.guid,
					parentGuid: "",
					referenceGuid: "",
					referenceType: "",
					status: 1,
					type: "userDocuments",
				});

				folderManager.save(newProjectFolder)
				.then(saveClientResponse => {
					if (saveClientResponse.status === "ok") {
						alert(`Cartella automatica per il Venditore ${currUser.__fullName} creata con successo!`);
						Shark.set({
							__showCreateAgentAutofolderBtn: false
						});
						Shark.render();
					}
				});
			}
		});
	}

	createClientsAutofolder (currUser) {
		folderManager.getListByAgent("", currUser.guid)
		.then(nousResponse => {
			const clientsFolder = Utils.safp(nousResponse.data, "type", "clients");

			if (!clientsFolder) {
				const newProjectFolder = Shark.getInstance("Folder", {
					clientGuid: "",
					name: "Clienti",
					ownerGuid: currUser.guid,
					parentGuid: "",
					referenceGuid: "",
					referenceType: "",
					status: 1,
					type: "clients",
				});

				folderManager.save(newProjectFolder)
				.then(saveClientResponse => {
					if (saveClientResponse.status === "ok") {
						alert(`Cartella automatica per i clienti di ${currUser.__fullName} creata con successo!`);
						Shark.set({
							__showCreateClientsAutofolderBtn: false
						});
						Shark.render();
					}
				});
			}
		});
	}

	createAgentAutofolderBtn_clickHandler () {
		const currUser = Shark.get("editingUser");
		this.createAgentAutofolder(currUser);
	}

	createClientsAutofolderBtn_clickHandler () {
		const currUser = Shark.get("editingUser");
		this.createClientsAutofolder(currUser);
	}

	deleteUserBtn_clickHandler () {
		if (confirm("Sicuro di voler cancellare questo utente?")) {
			userManager.delete(Shark.get("editingUser"));
		}
	}

	editUserBtn_clickHandler () {
		Shark.set("isEditingUser", true);
		this.set({
			isEditingUserUser: Shark.get("isEditingUser")
		});
		Shark.render();
	}

	init () {
		this.addComponents([informationModalComponent, mainNavComponent]);
	}

	saveUserBtn_clickHandler () {
		const currUser = Shark.get("editingUser");
		const errors = currUser.validate();

		if (errors.length > 0) {
			informationModalComponent.show({body: `Si sono verificati i seguenti errori:<br>${errors.join("<br>")}`, title: "Attenzione"});
			this.showErrors();
		}
		else {
			userManager.save(currUser)
			.then(userSaveResponse => {
				console.log({userSaveResponse});

				if (!userSaveResponse?.errors?.length) {
					if (currUser.hasRole("sellRepresentative")) {
						this.createAgentAutofolder(currUser);
						this.createClientsAutofolder(currUser);
					}
					
					Shark.set({
						isEditingUser: false,
					});
					this.set({
						isEditingUserUser: false,
					});
					Shark.render();
				}
				else {
					informationModalComponent.show({body: `Si sono verificati i seguenti errori:<br>${userSaveResponse.errors.map(item => item.error).join("<br>")}`, title: "Attenzione"});
				}
			});
		}
	}

	resetErrors () {
		document.querySelectorAll(".is-invalid").forEach(item => item.classList.remove("is-invalid"));
	}

	showErrors () {
		this.resetErrors();

		const currUser = Shark.get("editingUser");

		for (let currProp in currUser.__errors) {
			if (currUser.__errors[currProp] === true) {
				document.querySelectorAll(`[data-sh-prop="${currProp}"]`).forEach(item => item.classList.add("is-invalid"));
			}
		}
	}






	
	cancelEditsBtn_clickHandler () {
		const currUser = Shark.get("editingUser");

		if (!currUser.isDirty() || confirm("Sei sicuro di voler annulare? Le modifiche inserite andranno perse!")) {
			Shark.get("editingUser").restore();
			Shark.set("isEditingUser", false);
			this.set({
				isEditingUserUser: Shark.get("isEditingUser")
			});

			if (currUser.guid === "") {
				Shark.openPage(userListView);
			}
			else {
				Shark.render();
			}
		}
	}


	uploadedThumbnail_changeHandler (event) {
		userManager.upload(event.target);
	}

	userManager_fileAlreadyPresentErrorHandler (event, data) {
		if (confirm("Il file che stai cercando di caricare esiste già. Vuoi comunque caricarlo?")) {
			userManager.uploadDuplicate(data);
		}
		else {
			const newUser = Shark.get("editingUser");
			newUser.set("pictureURL", "");
			Shark.render();
		}
	}

	profileImageDeleteBtn_clickHandler () {
		Shark.get("editingUser").set("pictureURL", "");
		Shark.render();
	}

	userManager_deletedHandler () {
		Shark.set("isEditingUser", false);
		Shark.openPage(userListView);
	}
}

const userEditView = new UserEditView();

Shark.registerView(userEditView);

export default userEditView;
